import Component_FireProcedural_715e5c669e91fa59c1404c8271c09c5f from "../../../../content/examples/textures/procedural-fire/FireProcedural";
import Devtool_FireProcedural_715e5c669e91fa59c1404c8271c09c5f from "!!@devtool/loader!../../../../content/examples/textures/procedural-fire/FireProcedural";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_FireProcedural_715e5c669e91fa59c1404c8271c09c5f,
  Devtool_FireProcedural_715e5c669e91fa59c1404c8271c09c5f,
  DevTool,
  React
};